import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TShirtSizesFormComponent } from 'ag-common-svc/lib/components/t-shirt-sizes-form/t-shirt-sizes-form.component';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import {
  TShirtSizeDropdownModule
} from 'ag-common-svc/lib/components/t-shirt-size-dropdown/t-shirt-size-dropdown.module';
import { TShirtSizesFormService } from 'ag-common-svc/lib/components/t-shirt-sizes-form/t-shirt-sizes-form.service';

@NgModule({
  declarations: [TShirtSizesFormComponent],
  imports: [ CommonModule, SharedModule, TShirtSizeDropdownModule ],
  exports: [TShirtSizesFormComponent],
})
export class TShirtSizesFormModule {}
